import type { Ref } from 'vue';
import { ref, watch } from 'vue';
import { MarketTab } from '@/interface/enum';

export function useMoreMarketTabExpansion(marketTab: Ref<MarketTab>) {
    const isOpenMoreMarket = ref(false);
    const expansionBeforeBetBuilder = ref(false);

    watch(marketTab, (newVal, oldVal) => {
        if (newVal === MarketTab.BetBuilder) {
            expansionBeforeBetBuilder.value = isOpenMoreMarket.value;
            isOpenMoreMarket.value = true;
        } else if (oldVal === MarketTab.BetBuilder) {
            isOpenMoreMarket.value = expansionBeforeBetBuilder.value;
        }
    });

    return {
        isOpenMoreMarket,
    };
}
